export const getBlogSearch = async (query) => {
    try {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL}/items/blog?filter={ "name": { "_icontains": "${query}" }}&fields=banner, name, author, published_date, tags,content, content_read_time, slug, redirect_url`
      );
      if (response.ok) {
        const responseData = await response.json();
        return responseData.data;
      }
    } catch (error) {
      console.log(error);
    }
  };
  